/* Theme behaviour: dark mode, drawer, gallery, variants, qty, countdown,
   scroll reveal, hero carousel, brand strip */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- dark / light mode ---------- */
  var root = document.documentElement;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (!t) return;
    var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem('theme-mode', next); } catch (err) {}
  });

  /* ---------- drawer menu ---------- */
  var drawer = document.getElementById('DrawerMenu');
  var overlay = document.getElementById('DrawerOverlay');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); setDrawer(true); }
    else if (e.target.closest('[data-drawer-close]') || e.target === overlay) setDrawer(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------- drawer category accordion ---------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-acc-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var group = toggle.closest('[data-acc]');
    var panel = group && group.querySelector('[data-acc-panel]');
    if (!panel) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
  });

  /* ---------- header dropdown (touch + keyboard) ----------
     Hover is handled in CSS. This covers devices with no hover, where the
     parent link alone would make the submenu unreachable. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sub-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('[data-sub]');
      var open = wrap.hasAttribute('data-open');
      document.querySelectorAll('[data-sub][data-open]').forEach(function (w) {
        w.removeAttribute('data-open');
        var t = w.querySelector('[data-sub-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        wrap.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    // Click anywhere else closes any open dropdown.
    if (!e.target.closest('[data-sub-panel]')) {
      document.querySelectorAll('[data-sub][data-open]').forEach(function (w) {
        w.removeAttribute('data-open');
        var t = w.querySelector('[data-sub-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-sub][data-open]').forEach(function (w) {
      w.removeAttribute('data-open');
      var t = w.querySelector('[data-sub-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  });

  /* ---------- product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var wrap = thumb.closest('[data-gallery]');
    var main = wrap && wrap.querySelector('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.dataset.full;
    main.alt = thumb.dataset.alt || '';
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
    });
  });

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v += btn.dataset.qty === 'up' ? 1 : -1;
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- variant selection ---------- */
  var form = document.querySelector('[data-variant-form]');
  if (form) {
    var variants = [];
    try { variants = JSON.parse(document.getElementById('VariantData').textContent); } catch (err) {}

    var priceEl = document.querySelector('[data-price]');
    var idInput = form.querySelector('[name="id"]');
    var addBtn = form.querySelector('[data-add]');
    var money = form.dataset.moneyFormat || '${{amount}}';

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    function currentOptions() {
      return Array.from(form.querySelectorAll('[data-opt-index]'))
        .reduce(function (acc, group) {
          var checked = group.querySelector('input:checked');
          acc[parseInt(group.dataset.optIndex, 10)] = checked ? checked.value : null;
          return acc;
        }, []);
    }

    function update() {
      var chosen = currentOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price > 0 ? fmt(match.price) : priceEl.dataset.poaLabel || 'Contact for price';
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? (addBtn.dataset.labelAdd || 'Add to cart')
          : (addBtn.dataset.labelSold || 'Sold out');
      }
      if (match.featured_image && match.featured_image.src) {
        var main = document.querySelector('[data-gallery-main]');
        if (main) main.src = match.featured_image.src;
      }
      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-opt-input]')) update();
    });
  }

  /* ---------- countdown ---------- */
  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      var slots = el.querySelectorAll('b');
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        var parts = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
        slots.forEach(function (b, i) { b.textContent = String(parts[i]).padStart(2, '0'); });
        if (diff > 0) setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- scroll reveal ----------
     Fade + slight rise, once per element. Anything not observed stays visible,
     so a failed observer can never hide content. */
  var revealObserver = null;
  function initReveal(scope) {
    var targets = (scope || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!targets.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }

    targets.forEach(function (el) {
      var stagger = el.matches('[data-reveal-stagger]') ? el : el.querySelector('[data-reveal-stagger]');
      if (stagger) {
        Array.prototype.forEach.call(stagger.children, function (child, i) {
          if (!child.style.getPropertyValue('--i')) child.style.setProperty('--i', i);
        });
      }
      revealObserver.observe(el);
    });
  }

  /* ---------- hero carousel ---------- */
  function initHero(hero) {
    if (hero.dataset.heroReady) return;
    hero.dataset.heroReady = '1';

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var delay = parseInt(hero.dataset.heroDelay, 10) || 5500;
    var autoplayWanted = hero.dataset.heroAutoplay !== 'false';
    var index = 0;
    var timer = null;
    var hovered = false;
    var focused = false;

    function canAutoplay() {
      return autoplayWanted && !reduceMotion.matches && !hovered && !focused && !document.hidden;
    }

    function paint() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.classList.remove('is-timing');
      });
      // Restart the dot progress animation from zero.
      if (dots[index]) {
        void dots[index].offsetWidth;
        dots[index].classList.add('is-timing');
      }
    }

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      paint();
      schedule();
    }

    function stop() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function schedule() {
      stop();
      hero.classList.toggle('is-paused', !canAutoplay());
      if (!canAutoplay()) return;
      timer = setTimeout(function () { goTo(index + 1); }, delay);
    }

    hero.addEventListener('mouseenter', function () { hovered = true; schedule(); });
    hero.addEventListener('mouseleave', function () { hovered = false; schedule(); });
    hero.addEventListener('focusin', function () { focused = true; schedule(); });
    hero.addEventListener('focusout', function () {
      focused = hero.contains(document.activeElement);
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10) || 0); });
    });

    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    // Touch swipe.
    var startX = null;
    var viewport = hero.querySelector('[data-hero-viewport]') || hero;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      hovered = true;
      schedule();
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      hovered = false;
      if (Math.abs(dx) > 45) goTo(index + (dx < 0 ? 1 : -1));
      else schedule();
    }, { passive: true });

    reduceMotion.addEventListener('change', schedule);
    paint();
    schedule();
  }

  /* ---------- product rail arrows ----------
     The track stays a native scroll container; the arrows just page it. */
  function initRail(wrap) {
    if (wrap.dataset.railReady) return;
    wrap.dataset.railReady = '1';

    var track = wrap.querySelector('[data-rail-track]');
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    if (!track || !prev || !next) return;

    function pageSize() {
      // Just under a full viewport so the next card peeks in and signals more.
      return Math.max(220, track.clientWidth * 0.8);
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 2;
      prev.disabled = !scrollable || track.scrollLeft <= 2;
      next.disabled = !scrollable || track.scrollLeft >= max - 2;
    }

    function page(dir) {
      track.scrollBy({
        left: dir * pageSize(),
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    track.addEventListener('scroll', update, { passive: true });

    if ('ResizeObserver' in window) {
      wrap._railRO = new ResizeObserver(update);
      wrap._railRO.observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    window.addEventListener('load', update);
    update();
  }

  /* ---------- brand strip ----------
     Native scroll container, so swipe and trackpad work without help.
     rAF nudges scrollLeft for the marquee and wraps off a cloned track. */
  function initBrands(el) {
    if (el.dataset.brandsReady) return;
    el.dataset.brandsReady = '1';

    var viewport = el.querySelector('[data-brands-viewport]');
    var track = el.querySelector('[data-brands-track]');
    if (!viewport || !track || !track.children.length) return;

    var speed = parseFloat(el.dataset.brandsSpeed) || 35;
    var autoWanted = el.dataset.brandsAutoscroll !== 'false';
    var clones = [];
    var loopWidth = 0;
    var built = false;
    var paused = false;
    var raf = null;
    var last = 0;

    // Clone the track until there is enough content to scroll through.
    // Bails out until the strip has actually been laid out — widths of 0 would
    // otherwise "succeed" with zero clones and leave the marquee dead.
    function buildClones() {
      if (!track.offsetWidth || !viewport.offsetWidth) return;

      clones.forEach(function (c) { c.remove(); });
      clones = [];

      var gap = parseFloat(getComputedStyle(viewport).columnGap) || 0;
      loopWidth = track.offsetWidth + gap;
      var needed = viewport.offsetWidth + loopWidth;
      var total = loopWidth;

      while (total < needed && clones.length < 8) {
        var clone = track.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-brands-track');
        clone.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
        viewport.appendChild(clone);
        clones.push(clone);
        total += loopWidth;
      }
      built = true;
    }

    function canRun() {
      return autoWanted && !reduceMotion.matches && !paused && !document.hidden &&
        clones.length > 0 && viewport.scrollWidth > viewport.offsetWidth;
    }

    function frame(now) {
      if (!last) last = now;
      var dt = Math.min(now - last, 50);
      last = now;

      // Self-heal: fonts, images and lazy layout can all leave the strip
      // unmeasurable at init. Keep trying until it lays out, then stop.
      if (!built) buildClones();

      if (canRun()) viewport.scrollLeft += speed * dt / 1000;

      // Wrap forward whatever moved the strip — autoscroll, swipe or arrows.
      if (loopWidth && viewport.scrollLeft >= loopWidth) viewport.scrollLeft -= loopWidth;

      raf = requestAnimationFrame(frame);
    }

    function pause() { paused = true; }
    function resume() { paused = false; last = 0; }

    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', function () {
      if (!el.contains(document.activeElement)) resume();
    });
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('touchend', function () {
      setTimeout(resume, 2500);
    }, { passive: true });

    function nudge(dir) {
      pause();
      var amount = Math.max(200, viewport.offsetWidth * 0.7);
      // scrollLeft can't go below 0, so hop a full loop forward first and
      // scroll back from there. Visually identical, and "prev" never stalls.
      if (dir < 0 && loopWidth && viewport.scrollLeft - amount < 0) {
        viewport.scrollLeft += loopWidth;
      }
      viewport.scrollBy({
        left: dir * amount,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      setTimeout(resume, 2500);
    }
    var prev = el.querySelector('[data-brands-prev]');
    var next = el.querySelector('[data-brands-next]');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    // Only rebuild when the viewport genuinely resized. Appending clones fires
    // the observer again, and without this guard that thrashes every frame.
    var lastWidth = 0;
    function rebuild() {
      if (viewport.offsetWidth === lastWidth) return;
      lastWidth = viewport.offsetWidth;
      built = false;
      buildClones();
    }

    buildClones();
    if ('ResizeObserver' in window) {
      el._brandsRO = new ResizeObserver(rebuild);
      el._brandsRO.observe(viewport);
    } else {
      window.addEventListener('resize', rebuild);
    }
    window.addEventListener('load', rebuild);

    raf = requestAnimationFrame(frame);
  }

  /* ---------- boot ---------- */
  function initAll(scope) {
    var root = scope || document;
    initReveal(root);
    root.querySelectorAll('[data-hero]').forEach(initHero);
    root.querySelectorAll('[data-rail]').forEach(initRail);
    root.querySelectorAll('[data-brands]').forEach(initBrands);
    initCountdowns(root);
  }

  initAll(document);

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  });
})();
